import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 32px;
  position: relative;
`;
